import { render, staticRenderFns } from "./CollectionFilterProductType.vue?vue&type=template&id=16d8d17e&lang=pug&"
import script from "./CollectionFilterProductType.vue?vue&type=script&lang=js&"
export * from "./CollectionFilterProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d8d17e')) {
      api.createRecord('16d8d17e', component.options)
    } else {
      api.reload('16d8d17e', component.options)
    }
    module.hot.accept("./CollectionFilterProductType.vue?vue&type=template&id=16d8d17e&lang=pug&", function () {
      api.rerender('16d8d17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionFilterProductType.vue"
export default component.exports